import React from 'react';
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AppLoggedOut from './components/AppLoggedOut';
import Session from './components/Account/Session';
import NotFound from './components/NotFound';
import AppNoNav from './components/AppNoNav';
import UpdatePassword from './components/Account/UpdatePassword';
import App from './components/App';
import Locations from './components/Locations/Locations';
import { Validate } from './config';
import Inbox from './components/Messages/Inbox';
import Payments from './components/Payments/Payments';
import HybridProctoring from './components/Hybrid/HybridProctoring';
import HybridSettings from './components/Hybrid/HybridSettings';
import Policies from './components/Policies/Policies';
import Reports from './components/Reports/Reports';
import Downloads from './components/Reports/Downloads';
import Users from './components/Users/Users';
import RegisterIntro from './components/Register/Intro';
import RegisterForm from './components/Register/RegisterForm';
import CheckupIntro from './components/Checkup/Intro';
import CheckupForm from './components/Checkup/Form';
import Sessions from './components/Sessions/Sessions';
import SessionsPending from './components/Sessions/SessionsPending';
import SessionDetail from './components/Sessions/SessionDetail';
import Settings from './components/Settings/Settings';
import SupportTickets from './components/SupportTickets/SupportTickets';
import SessionExpired from './components/SessionExpired';
import Unauthorized from './components/Unauthorized';
import Dashboard from './components/Dashboard/Dashboard';
import AppointmentTimeline from "./components/Calendar/AppointmentTimeline"
import CheckoutQueue from './components/Checkout/CheckoutQueue';

const AppRouter =  observer( class AppRouter extends React.Component {

  render() {
    let props = this.props;
    return (
    <Router>
      <Route
        render={({location}) => (
          <Switch location={location}>
            <Route exact path="/reports/appointment-timeline" render={routing => <App routing={routing} {...props}><AppointmentTimeline routing={routing} {...props} /></App>}/>

            <Route exact path="/account/sign-up" render={routing => <Session routing={routing} {...props} content="SignUp"/>}/>
            <Route exact path="/account/sign-in" render={(routing) => <Session routing={routing} {...props} content="SignIn"/>}/>
            <Route exact path="/reset-password" render={(routing) => <Session routing={routing} {...props} content="Reset"/>}/>
                <Route exact path="/update-password" render={(routing) => <AppNoNav><UpdatePassword routing={routing} {...props} /></AppNoNav>}/>
            <Route exact path="/locations"  render={(routing) =>(<App {...props} routing={routing} feature="locations"><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/locations/edit/:locationId" render={(routing) =>(<App routing={routing} {...props} feature="locations" ><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/locations/add" render={(routing) =>(<App routing={routing} {...props}  feature="locations"><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/locations/schedule/:scheduleLocation" render={(routing) =>(<App routing={routing} {...props} feature="locations" ><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/locations/schedule/:scheduleLocation/calendar/:calendarId" render={(routing) =>(<App routing={routing} {...props} feature="locations"><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/locations/schedule/:scheduleLocation/view/:calendarId" render={(routing) =>(<App routing={routing} {...props}  feature="locations" ><Locations {...props} Validate={Validate}/></App>)}/>
            <Route exact path="/messages"  render={(routing) => <App feature="messages" routing={routing} {...props}><Inbox {...props} /></App>}/>
            <Route exact path="/messages/view/:messageId" render={(routing) => <App feature="messages" routing={routing} {...props}><Inbox {...props} /></App>}/>
            <Route exact path="/detail/:messageId" render={(routing) => <App feature="messages" routing={routing} {...props}><Inbox {...props} /></App>}/>
            <Route exact path="/payments" render={(routing) => <App feature="payments" routing={routing} {...props}><Payments {...props} /></App>}/>
            <Route exact path="/hybrid-proctoring" render={routing => ( <App feature="hybrid-proctoring" routing={routing} {...props}><HybridProctoring {...props}/></App>)}/>
            <Route exact path="/room/edit/:roomSid" render={(routing => ( <App feature="hybrid-proctoring" routing={routing} {...props}><HybridSettings  setCreateNew={false} {...props}/></App>))}/>
            <Route exact path="/policies" render={routing => (<App feature="policies" routing={routing} {...props}><Policies {...props} /></App>)}/>
            <Route path="/reports/downloads" render={(routing) =><App {...props} routing={routing}><Downloads routing={routing} {...props}/></App>}/>
            <Route path="/reports" render={routing => (<App feature="reports" routing={routing} {...props}><Reports {...props} /></App>)}/>
            <Route exact path="/users" render={(routing) => <App feature="users" routing={routing} {...props}><Users  {...props}/></App>}/>
            <Route exact path="/register" render={(routing) =><AppNoNav><RegisterIntro routing={routing} {...props}/></AppNoNav>}/>
            <Route exact path="/register/step-01" render={(routing) => <AppNoNav routing={routing} {...props} ><RegisterForm routing={routing} {...props} step={1}/></AppNoNav>}/>
            <Route exact path="/register/step-02" render={(routing) => <AppNoNav routing={routing} {...props} ><RegisterForm routing={routing} {...props} step={2}/></AppNoNav>}/>
            <Route exact path="/register/step-03" render={(routing) => <AppNoNav routing={routing} {...props} ><RegisterForm routing={routing} {...props} step={3}/></AppNoNav>}/>
            <Route exact path="/register/step-04" render={(routing) =><AppNoNav routing={routing} {...props} ><RegisterForm routing={routing} {...props} step={4}/></AppNoNav>}/>
            <Route exact path="/register/step-05" render={(routing) => <AppNoNav routing={routing} {...props} ><RegisterForm  routing={routing} {...props} step={5}/></AppNoNav>}/>
            <Route exact path="/checkup" render={(routing) => <AppNoNav feature="onboarding" routing={routing} {...props}><CheckupIntro {...props}/></AppNoNav>}/>
            <Route exact path="/checkup/step-01" render={(routing) => <AppNoNav feature="onboarding" routing={routing} {...props}><CheckupForm {...props} step={1}/></AppNoNav>}/>
            <Route exact path="/checkup/step-02" render={(routing) => <AppNoNav feature="onboarding" routing={routing} {...props}><CheckupForm {...props} step={2}/></AppNoNav>}/>
            <Route exact path="/checkup/step-03" render={(routing) => <AppNoNav feature="onboarding" routing={routing} {...props}><CheckupForm {...props} step={3}/></AppNoNav>}/>
            <Route exact path="/checkup/step-04" render={(routing) => <AppNoNav feature="onboarding"routing={routing} {...props} ><CheckupForm {...props} step={4}/></AppNoNav>}/>
            <Route exact path="/checkup/step-05" render={(routing) => <AppNoNav feature="onboarding" routing={routing} {...props}><CheckupForm {...props} step={5}/></AppNoNav>}/>
            <Route exact path="/checkup/step-06" render={(routing) => <AppNoNav feature="onboarding"routing={routing} {...props}><CheckupForm {...props} step={6}/></AppNoNav>}/>
            <Route exact path="/sessions" render={(routing) => <App feature="sessions" routing={routing} {...props}><Sessions {...props} /></App>}/>
            <Route exact path="/sessions/:sessionId" render={(routing) => <App feature="sessions" routing={routing} {...props}><Sessions {...props}/></App>}/>
            <Route exact path="/pending-sessions" render={(routing) =><App feature="pending-sessions" routing={routing} {...props}><SessionsPending {...props}/></App>}/>
            <Route exact path="/view-session/:sessionId" render={(routing) => <SessionDetail routing={routing} {...props} feature="sessions"/>}/>
            <Route exact path="/settings"  render={routing => <App feature="settings" content="User" routing={routing} {...props}><Settings {...props} /></App>}/>
            <Route exact path="/support" render={routing => <App feature="support"routing={routing} {...props} ><SupportTickets {...props} /></App>}/>
            <Route exact path="/support/view/:ticketId" render={routing => <App feature="support"routing={routing} {...props} ><SupportTickets {...props} /></App>}/>
            <Route exact path="/support/add" render={routing => <App feature="support" routing={routing} {...props} ><SupportTickets {...props} /></App>}/>
            <Route exact path="/session-expired" render={(routing) => <AppLoggedOut routing={routing} {...props}><SessionExpired {...props}/></AppLoggedOut>}/>
            <Route exact path="/checkout" render={(routing) => <App feature="checkout" routing={routing} {...props}><CheckoutQueue {...props} /></App>} />

            <Route exact path="/unauthorized" render={(routing) => <App routing={routing}{...props}><Unauthorized{...props}/></App>}/>
            <Route exact path="/refresh" render={null}/>
            <Route exact path="/" render={(routing) => <App feature="dashboard" routing={routing} {...props}><Dashboard  {...props}/></App>}/>
            <Route exact path="/index.html" render={(routing) => <Dashboard routing={routing} {...props} />}/>
            <Route path="/#/*" render={(routing) => <App feature="dashboard" routing={routing} {...props}><Dashboard  {...props}/></App>}/>
            <Route path="*" render={(routing) => <NotFound routing={routing} {...props}/>}/>
          </Switch>
        )}
      />
    </Router>
    )
  }
});

/*
  LEAVING THIS HERE FOR REFERENCE
  <Provider {...stores}>
    <Switch history={history} {...stores}>
      <Route path="account" component={AppLoggedOut}>
        <Route path="sign-up" component={(props) => <Session {...stores} content="SignUp" />} />
        <Route path="sign-in" component={(props) => <Session {...stores} content="SignIn" />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route path="reset-password" component={AppLoggedOut}>
        <IndexRoute component={(props) => <Session {...stores} content="Reset" />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route path="update-password" component={AppNoNav}>
        <IndexRoute component={(props) => <UpdatePassword {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="locations"
        component={App}
        feature="locations"
      >
        <IndexRoute component={(props) => <Locations {...stores} Validate={Validate} />} />
        <Route path="edit/:locationId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
        <Route path="add" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
        <Route path="schedule/:scheduleLocation" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
        <Route path="schedule/:scheduleLocation/calendar/:calendarId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
        <Route path="schedule/:scheduleLocation/view/:calendarId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
        path="messages"
        component={App}
        feature="messages"
      >
        <IndexRoute component={(props) => <Messages {...stores} />} />
        <Route path="view/:messageId" component={(props) => <Messages {...stores} />} />
        <Route path="detail/:messageId" component={(props) => <Messages {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
        path="payments"
        component={App}
        feature="payments"
      >
        <IndexRoute component={(props) => <Payments {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
          path="hybrid-proctoring"
          component={App}
          feature="hybrid-proctoring"
      >
        <IndexRoute component={(props) => <HybridProctoring {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
          path="room/edit/:roomSid"
          component={App}
          feature="hybrid-proctoring"
      >
        <IndexRoute component={(props) => <HybridSettings {...stores} setCreateNew={false} />} />
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
        path="policies"
        component={App}
        feature="policies"
      >
        <IndexRoute component={(props) => <Policies {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
      </Route>
      <Route
        path="reports"
        component={App}
        feature="reports"
      >
        <IndexRoute component={(props) => <Reports {...stores} />} />
        <Route path="downloads" component={(props) => <Downloads {...stores} />} />
        <Route path="*" component={(props) => <Reports {...stores} />} />
      </Route>
      <Route
        path="users"
        component={App}
        feature="users"
      >
        <IndexRoute component={(props) => <Users {...stores} />} />
        <Route path="users" component={(props) => <Users {...stores} />} />
        <Route path="*" component={(props) => <Users {...stores} />} />
      </Route>
      <Route
        path="register"
        component={AppNoNav}
        feature="register"
      >
        <IndexRoute component={(props) => <RegisterIntro {...stores} />} />
        <Route path="step-01" component={(props) => <RegisterForm {...stores} step={1} />} />
        <Route path="step-02" component={(props) => <RegisterForm {...stores} step={2} />} />
        <Route path="step-03" component={(props) => <RegisterForm {...stores} step={3} />} />
        <Route path="step-04" component={(props) => <RegisterForm {...stores} step={4} />} />
        <Route path="step-05" component={(props) => <RegisterForm {...stores} step={5} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="checkup"
        component={AppNoNav}
        feature="onboarding"
      >
        <IndexRoute component={(props) => <CheckupIntro {...stores} />} />
        <Route path="step-01" component={(props) => <CheckupForm {...stores} step={1} />} />
        <Route path="step-02" component={(props) => <CheckupForm {...stores} step={2} />} />
        <Route path="step-03" component={(props) => <CheckupForm {...stores} step={3} />} />
        <Route path="step-04" component={(props) => <CheckupForm {...stores} step={4} />} />
        <Route path="step-05" component={(props) => <CheckupForm {...stores} step={5} />} />
        <Route path="step-06" component={(props) => <CheckupForm {...stores} step={6} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="sessions"
        component={App}
        feature="sessions"
      >
        <IndexRoute component={(props) => <Sessions {...stores} />} />
        <Route path=":sessionId" component={(props) => <Sessions {...stores} />}></Route>
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="pending-sessions"
        component={App}
        feature="pending-sessions"
      >
        <IndexRoute component={(props) => <SessionsPending {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="view-session/:sessionId"
        component={App}
        feature="sessions"
      >
        <IndexRoute component={(props) => <SessionDetail {...stores} />} />
      </Route>
      <Route
        path="settings"
        component={App}
        feature="settings"
      >
        <IndexRoute component={(props) => <Settings {...stores} content="User" />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="support"
        component={App}
        feature="support"
      >
        <IndexRoute component={(props) => <SupportTickets {...stores} />} />
        <Route path="view/:ticketId" component={(props) => <SupportTickets {...stores} />} />
        <Route path="add" component={(props) => <SupportTickets {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route path="session-expired" component={AppLoggedOut}>
        <IndexRoute component={(props) => <SessionExpired {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="unauthorized"
        component={App}
      >
        <IndexRoute component={(props) => <Unauthorized {...stores} />} />
        <Route path="unauthorized" component={(props) => <Unauthorized {...stores} />}/>
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route path="refresh" component={null} />
      <Route
        path="/"
        component={App}
        feature="dashboard"
      >
        <IndexRoute component={(props) => <Dashboard {...stores} />} />
        <Route path="index.html" component={(props) => <Dashboard {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
    </Router>
  </Provider>
 */
export default AppRouter;


// WEBPACK FOOTER //
// ./src/app/routes.js